








































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import { HeaderWidthItem } from "@/types";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { getDefaultMonth } from "@/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    LoadingDialog
  }
})
export default class BillingList extends mixins(AxiosMixin) {
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  //=================================================================
  // 請求一覧（詳細）
  //=================================================================
  //項目
  private headerItems: HeaderWidthItem[] = [
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "110px"
    },
    {
      value: "name",
      text: "氏名",
      width: "150px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "150px"
    },
    {
      value: "payment_method",
      text: "支払方法",
      width: "100px"
    },
    {
      value: "visit_counts",
      text: "訪問回数",
      width: "100px"
    },
    {
      value: "total",
      text: "合計",
      width: "90px"
    },
    {
      value: "medical_insurance",
      text: "医療/国保連",
      width: "120px"
    },
    {
      value: "medical_paymentfund",
      text: "医療/支払基金",
      width: "140px"
    },
    {
      value: "medical_ownexpense",
      text: "医療/自己負担",
      width: "140px"
    },
    {
      value: "adjust_amount1",
      text: "医療/調整",
      width: "120px"
    },
    {
      value: "care_insurance",
      text: "介護/保険",
      width: "120px"
    },
    {
      value: "care_publicexpenditure",
      text: "介護/公費",
      width: "120px"
    },
    {
      value: "care_ownexpense",
      text: "介護/自己負担",
      width: "140px"
    },
    {
      value: "adjust_amount2",
      text: "介護/調整",
      width: "120px"
    },
    {
      value: "ownexpense",
      text: "自費",
      width: "90px"
    },
    {
      value: "date_of_service",
      text: "サービス提供年月",
      width: "150px"
    }
  ];

  //データテーブル
  private tableItems: object[] = [];

  //=================================================================
  // データテーブルのスタイル用
  //=================================================================
  private isTableScroll = true;

  //=================================================================
  // 対象年月
  //=================================================================
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }

  //=================================================================
  // 検索ボタン
  //=================================================================
  private search() {
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetails/get",
      {
        yearmonth: this.yearmonth.replace("-", "")
      },
      res => {
        this.tableItems = res.data.billinglist;
        this.$router;

        //データテーブルのスタイル切り替え
        this.isTableScroll = true;
        this.$nextTick(() => {
          this.onresize();
        });
      }
    );
  }

  //=================================================================
  // ダウンロードボタン
  //=================================================================
  private download() {
    const param = {
      table_items: this.tableItems
    };

    const fname = `請求一覧（詳細）_${this.yearmonth}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/billinglistdetails/download",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    // リサイズイベント登録
    window.onresize = () => {
      this.onresize();
    };

    const ym = localStorage.getItem("yearmonth");
    this.yearmonth = ym ? String(ym) : getDefaultMonth().substr(0, 7);

    this.search();
  }

  beforeDestroy() {
    window.onresize = null;
  }

  //---------------------------------------------
  //リサイズイベント
  //---------------------------------------------
  private onresize() {
    // データテーブルのスタイル切り替え
    this.isTableScroll = true;
    const dataTable = document.getElementById(
      "data-table"
    ) as HTMLElement | null;
    if (dataTable) {
      const table = dataTable.children[0].children[0] as HTMLElement | null;
      if (table) {
        if (dataTable.offsetHeight >= table.offsetHeight) {
          // 成り行き
          const root = document.getElementById("root") as HTMLElement | null;
          if (dataTable && root) {
            const dr = dataTable.getBoundingClientRect();
            const rr = root.getBoundingClientRect();
            // console.log('rect', dr, rr)
            if (rr.bottom <= dr.bottom) {
              this.isTableScroll = true;
            } else {
              this.isTableScroll = false;
            }
          }
        } else {
          // スクロール
          this.isTableScroll = true;
        }
      }
    }
  }
}
